import { createRootRoute, createRouter } from '@tanstack/react-router'

import Root from '@/core/pages/root.page'
import GlobalError from '@/core/pages/global-error.page'
import GlobalNotFound from '@/core/pages/global-not-found.page'

import {
  authRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  signInRoute,
} from '@/modules/auth/auth.routes'
import {
  dashboardNotFoundRoute,
  dashboardRoute,
  forbiddenRoute,
  homeRoute,
} from '@/modules/dashboard/dashboard.routes'
import {
  categoryListRoute,
  categoryRoute,
} from '@/modules/category/category.routes'
import {
  questionPoolListRoute,
  questionPoolRoute,
} from '@/modules/question-pool/question-pool.routes'
import {
  batchListRoute,
  batchReviewRoute,
  editDraftRoute,
  newGenerationRoute,
  questionGenerationRoute,
} from '@/modules/question-generation/question-generation.routes'
import {
  periodicCreateRoute,
  periodicEditRoute,
  periodicGenerationRoute,
  periodicListRoute,
} from '@/modules/periodic-generation/periodic-generation.routes'
import {
  periodCreateRoute,
  periodEditRoute,
  periodListRoute,
  periodRoute,
} from '@/modules/period/period.routes'
import {
  rolesCreateRoute,
  rolesDetailRoute,
  rolesEditRoute,
  rolesListRoute,
  rolesRoute,
} from '@/modules/role/role.routes'
import {
  usersCreateRoute,
  usersDetailRoute,
  usersEditRoute,
  usersListRoute,
  usersRoute,
} from '@/modules/user/user.routes'
import { auditListRoute, auditRoute } from '@/modules/audit/audit.routes'
import { profileRoute } from '@/modules/profile/profile.routes'

// Code-based routing (dashboard deseni; routeTree.gen.ts yok). Register tipi
// bilinçli olarak kaydedilmez — gevşek tipleme dashboard ile aynıdır.
export const rootRoute = createRootRoute({
  component: () => <Root />,
  errorComponent: ({ error }) => <GlobalError error={error} />,
  notFoundComponent: () => <GlobalNotFound />,
})

const routeTree = rootRoute.addChildren([
  authRoute.addChildren([signInRoute, forgotPasswordRoute, resetPasswordRoute]),

  dashboardRoute.addChildren([
    homeRoute,
    forbiddenRoute,
    profileRoute,
    dashboardNotFoundRoute,
  ]),

  categoryRoute.addChildren([categoryListRoute]),

  questionPoolRoute.addChildren([questionPoolListRoute]),

  questionGenerationRoute.addChildren([
    batchListRoute,
    newGenerationRoute,
    editDraftRoute,
    batchReviewRoute,
  ]),

  periodicGenerationRoute.addChildren([
    periodicListRoute,
    periodicCreateRoute,
    periodicEditRoute,
  ]),

  periodRoute.addChildren([
    periodListRoute,
    periodCreateRoute,
    periodEditRoute,
  ]),

  rolesRoute.addChildren([
    rolesListRoute,
    rolesCreateRoute,
    rolesDetailRoute,
    rolesEditRoute,
  ]),

  usersRoute.addChildren([
    usersListRoute,
    usersCreateRoute,
    usersDetailRoute,
    usersEditRoute,
  ]),

  auditRoute.addChildren([auditListRoute]),
])

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 30_000,
  scrollRestoration: true,
})
